import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Form, Button, Card, Alert, Spinner } from "react-bootstrap";
import { motion } from "framer-motion";
import { Upload, Mail, Phone, User, MapPin } from "lucide-react";
import './careers.css'
import axios from "axios";
import { toast } from "react-toastify";
let baseurl = process.env.REACT_APP_BASE_URL


const CareersPage = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    resume: null,
    location:""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    resume: "",
    location:""
  });
  const fileInputRef = useRef(null);


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
 setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
      isValid = false;
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
      isValid = false;
    }
    if (!formData.location.trim()) {
      newErrors.location = "Location is required";
      isValid = false;
    }
    else if(formData.location.length<3){
 newErrors.location = "Please Enter Valid Location";
      isValid = false;
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
      isValid = false;
    }
    if (!formData.mobile) {
      newErrors.mobile = "Mobile number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter a valid 10-digit number";
      isValid = false;
    }
    if (!formData.resume) {
      newErrors.resume = "Resume is required";
      isValid = false;
    } else if (
      formData.resume &&
      !["application/pdf", "application/msword", 
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ].includes(formData.resume.type)
    ) {
      newErrors.resume = "Only PDF, DOC, or DOCX allowed";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    
    setIsSubmitting(true);
    
    const formPayload = new FormData();
   formPayload.append("firstName", formData.firstName);
  formPayload.append("lastName", formData.lastName);
  formPayload.append("email", formData.email);
  formPayload.append("mobile", formData.mobile);
  formPayload.append("location", formData.location);
  // ✅ Append resume file
  if (formData.resume) {
    formPayload.append("resume", formData.resume); 
  }
    try{
         const res = await axios.post(`${baseurl}/api/happicareers`, formPayload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const result =await res.data
      if(result.success){
        toast.success(result.message);
        if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setFormData({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    location:"",
    resume: null})}
     else{
    toast.error('Please Try After Some Time');
  
    }
    }
   
    catch(e){
      toast.error('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
 
  };




  return (
    <>
    
    <Container fluid style={{backgroundColor:"#f47933"}}>
   
             <div className="d-flex justify-content-center align-items-center min-vh-100" >
                 <Row className="w-100 justify-content-center position-relative">
        <Col md={8} lg={6}>
           <img src="https://m.economictimes.com/thumb/msid-68943133,width-1200,height-900,resizemode-4,imgsize-36745/untitled-7.jpg" 
             alt="Happi Mobiles Logo" height={"200px"} width={"300px"} className="position-absolute" style={{left:0,top:-100}}/>
            <Card className="shadow-lg rounded-4 border-0">
               
              <Card.Body className="px-4 py-4">
                <h4 className="text-center mb-4">Want to Join our Happi Family! Enter your details below to get started.</h4>
                {false ? (
                  <Alert variant="success" className="text-center">
                    🎉 Thank you for applying! We'll get back to you soon.
                  </Alert>
                ) : (
                  <Form >
                    <Row className="mb-3">
                      <Col>
                        <Form.Group controlId="firstName">
                          <Form.Label>
                            <User size={18} className="me-2" />
                            First Name *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                          />
                        </Form.Group>
                         {errors.firstName && (
          <p className="text-red-500 text-sm text-danger">{errors.firstName}</p>
        )}
                      </Col>
                      <Col>
                        <Form.Group controlId="lastName">
                          <Form.Label>
                            <User size={18} className="me-2" />
                            Last Name *
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            required
                          />
                        </Form.Group>
                          {errors.lastName && (
          <p className="text-red-500 text-sm text-danger">{errors.lastName}</p>
        )}
                      </Col>
                    </Row>

                    <Form.Group className="mb-3" controlId="email">
                      <Form.Label>
                        <Mail size={18} className="me-2" />
                        Email *
                      </Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                       {errors.email && (
          <p className="text-red-500 text-sm text-danger">{errors.email}</p>
        )}
                    </Form.Group>

<Row>
    <Col><Form.Group className="mb-3" controlId="mobile">
                      <Form.Label>
                        <Phone size={18} className="me-2" />
                        Mobile Number *
                      </Form.Label>
                      <Form.Control
                        type="tel"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        required
                      />
                       {errors.mobile && (
          <p className="text-red-500 text-sm text-danger">{errors.mobile}</p>
        )}
                    </Form.Group></Col>
    <Col>
    <Form.Group className="mb-3" controlId="location">
                      <Form.Label>
                        <MapPin size={18} className="me-2" />
                        Location *
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="location"
                        value={formData?.location}
                        onChange={handleChange}
                        required
                      />
                       {errors.location && (
          <p className="text-red-500 text-sm text-danger">{errors.location}</p>
        )}
                    </Form.Group></Col>
</Row>

                    

                    <Form.Group className="mb-4" controlId="resume">
                      <Form.Label>
                        <Upload size={18} className="me-2" />
                        Upload Resume *
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="resume"
                        ref={fileInputRef}   // attach ref here
                        accept=".pdf,.doc,.docx"
                        onChange={handleChange}
                        required
                      />
                       {errors.resume && (
          <p className="text-sm text-danger">{errors.resume}</p>
        )}
                      <Form.Text className="text-muted">
                        Accepted formats: PDF, DOC, DOCX
                      </Form.Text>
                    </Form.Group>

                    <div className="d-grid">
                      <Button 
                        variant="primary" 
                        size="lg"  
                        onClick={handleSubmit} 
                        className="rounded-pill text-uppercase" 
                        style={{letterSpacing:'3px'}}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              className="me-2"
                            />
                            Submitting...
                          </>
                        ) : (
                          "Submit Application"
                        )}
                      </Button>
                    </div>
                  </Form>
                )}
              </Card.Body>
            </Card>
        </Col>
      </Row>
             </div>
     
    </Container>
    </>
  );
};

export default CareersPage;
